import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryPage } from '../../models/support-documentation';
import { OverlaySimulatorService } from '../../services/overlay-simulator.service';
import { SupportDocumentationService } from '../../services/support-documentation.service';

@Component({
  standalone: false,
  selector: 'sbnb-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
})
export class CategoryComponent implements OnInit {
  loading: boolean;
  slug: string;
  category: CategoryPage;
  fragment: string;

  constructor(
    public overlaySimulatorService: OverlaySimulatorService,
    private supportDocumentationService: SupportDocumentationService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loading = true;

    this.route.fragment.subscribe((fragment) => {
      this.fragment = fragment;
    });

    this.route.params.subscribe(({ slug }) => {
      this.slug = slug;

      if (!this.slug) {
        this.router.navigate(['/support-documentation']);
      }

      this.supportDocumentationService.getCategoryPage(this.slug).subscribe(
        (category: CategoryPage) => {
          this.overlaySimulatorService.rememberCurrentUrl();
          this.category = category;
          this.loading = false;
        },
        (err) => {
          this.router.navigate(['/support-documentation']);
        }
      );
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      try {
        document.getElementById(this.fragment).scrollIntoView();
      } catch (e) { }
    }, 500);
  }
}
